import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18n from '@/i18n'

import TemplateHelper from '@/utils/TemplateHelper'

import './index.scss'

class LastViewWidget extends Component {
    listRef
    scrollTop = 0

    handleClickPrev = () => {
        if (!this.listRef) return
        const { clientHeight } = this.listRef

        this.scrollTop = Math.max(0, this.scrollTop - clientHeight)
        this.listRef.scrollTo({ top: this.scrollTop, behavior: 'smooth' })
    }

    handleClickNext = () => {
        if (!this.listRef) return
        const { clientHeight, scrollHeight } = this.listRef

        this.scrollTop = Math.min(scrollHeight - clientHeight, this.scrollTop + clientHeight)
        this.listRef.scrollTo({ top: this.scrollTop, behavior: 'smooth' })
    }

    handleClickMoveTop = () => window.scrollTo({ top: 0, behavior: 'smooth' })

    render() {
        const { templates, lang } = this.props

        const list = TemplateHelper.GetRepresentedTemplates(templates, lang)
        if (!list) return null

        return (
            <div className="lastview-widget-root-contaier">
                <div className="heading">
                    {i18n.t("web.designselect.lastview.title")}
                </div>
                <div className="prev-btn" onClick={this.handleClickPrev}>
                    <img src="https://front.videomonster.com/images-u6yd72dy/web/lastview-widget-arrow.svg" alt="" />
                </div>

                <div className="list-wrapper" ref={ref => this.listRef = ref}>
                    {
                        list.map((template, index) => {
                            const groupData = templates[index]
                            return (
                                <div className="item" onClick={this.props.onThumbnailClicked(groupData, template.key)}>
                                    <img src={TemplateHelper.getThumbnailImage(template, lang, true) || ""} alt="" />
                                </div>
                            )
                        })
                    }
                </div>

                <div className="next-btn" onClick={this.handleClickNext}>
                    <img src="https://front.videomonster.com/images-u6yd72dy/web/lastview-widget-arrow.svg" alt="" />
                </div>

                {/* <div className="move-top-btn" onClick={this.handleClickMoveTop}>
                    <img src="https://front.videomonster.com/images-u6yd72dy/web/lastview-widget-movetop.png" alt="" />
                </div> */}
            </div>
        )
    }
}

const mapStateToProps = state => ({
    lang: state.langStore.lang
})

export default connect(mapStateToProps, null)(LastViewWidget)